//@ts-nocheck
import { useState } from 'react';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteApiData } from "../helpers/AxiosInstance";
import { toast } from "react-toastify";

interface ConfirmDialogState {
  isOpen: boolean;
  title: string;
  subTitle: string;
}

const useDeleteHook = ({ queryKey }) => {
  // Getting cached data from queryClient
  const queryClient = useQueryClient();
  const [confirmDialog, setConfirmDialog] = useState<ConfirmDialogState>({
    isOpen: false,
    title: '',
    subTitle: '',
  });

  const { isPending, mutateAsync, isSuccess, data, isError } = useMutation({
    mutationFn: deleteApiData,
    onSuccess: (data) => {
      toast.success("Item deleted successfully");
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.detail ?? "Something went wrong");
    },
    onSettled: () => {
      // Invalidate queries with the provided queryKey to refresh data
      queryClient.invalidateQueries(queryKey);
    },
  });

  return {
    isPending,
    mutateAsync,
    isSuccess,
    data,
    isError,
    confirmDialog,
    setConfirmDialog,
  };
};

export default useDeleteHook;
